import config from 'config'
import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { StorageManager } from '@vue-storefront/core/lib/storage-manager'
import { module } from './store'
import { stashOrderAccessToken, stripOrderAccessTokenFromLocation } from './helpers/orderAccessToken'

export const KEY = 'payment-kustom'

const KUSTOM_CHECKOUT_ROUTE = 'kustom-checkout'
const FALLBACK_CHECKOUT_ROUTE = 'checkout'

export const isKustomEnabled = (): boolean => config.kustom?.enabled !== false

/**
 * The fallback path for a Kustom checkout path, keeping any store-view prefix,
 * or null when the path is not the Kustom checkout.
 */
export const fallbackCheckoutPath = (routePath: string): string | null => {
  const segments = String(routePath || '').split('/').filter(Boolean)

  if (String(segments[segments.length - 1] || '').toLowerCase() !== KUSTOM_CHECKOUT_ROUTE) {
    return null
  }

  return `/${[...segments.slice(0, -1), FALLBACK_CHECKOUT_ROUTE].join('/')}`
}

export const PaymentKustomModule: StorefrontModule = function ({ store, router }) {
  StorageManager.init('kustom')
  store.registerModule(KEY, module)
  stripOrderAccessTokenFromLocation()

  if (!isKustomEnabled()) {
    router.beforeEach((to, from, next) => {
      const target = fallbackCheckoutPath(to.path)

      if (!target) {
        next()
        return
      }

      next({ path: target, query: to.query, hash: to.hash, replace: true })
    })
  }

  router.beforeEach((to, from, next) => stashOrderAccessToken(to, next))
}
